// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=2780-30318
// Figma component name: AddOns (collapsible card)
//
// Props:
//   children     — the addon rows (CheckboxField / BoosterField via Formik Field)
//   activePills  — string[] of selected addon labels shown in collapsed header
//   disabled     — locks the whole card
//   forceOpen    — always expanded (used in fullscreen mode)
//   title        — card header title

import { useState } from 'react'
import classnames from 'classnames'
import Pill from '~/components/ui/Pill'

function ChevronIcon({ open }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" className="shrink-0">
      <path
        d={open ? 'M6 15l6-6 6 6' : 'M6 9l6 6 6-6'}
        stroke="#17181A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default function AddOnsCard({ children, activePills = [], disabled, defaultOpen = false, title }) {
  const [open, setOpen] = useState(defaultOpen)
  const isOpen = open

  const theme = typeof CONFIG !== 'undefined' && CONFIG.svea_module ? 'svea-taxi' : 'taxi-stockholm'
  const base = `/app/themes/${theme}/static/img/option-icons`

  return (
    <div className={classnames(
      'flex flex-col w-full bg-surface-container-low rounded-[10px] overflow-hidden',
      disabled && 'opacity-[0.38] pointer-events-none',
    )}>
      {/* Header — tap to expand/collapse */}
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        disabled={disabled}
        className="bg-surface-container-high flex gap-3 items-center p-2 w-full text-left"
        aria-expanded={isOpen}
      >
        {/* Icon collage: pet + booster + child seat overlapping in 44px circle */}
        <div className="relative overflow-clip size-11 shrink-0 bg-surface-container">
          <img src={`${base}/Pet.png`}        alt="" className="absolute object-cover size-[34px]" style={{ left: -9, top: -4 }} />
          <img src={`${base}/BoosterSeat.png`} alt="" className="absolute object-cover size-[34px]" style={{ left: '50%', top: '50%', transform: 'translate(calc(-50% - 6px), calc(-50% + 11px))' }} />
          <img src={`${base}/ChildSeat.png`}  alt="" className="absolute object-cover size-[34px]" style={{ left: '50%', top: '50%', transform: 'translate(calc(-50% + 10px), calc(-50% - 10px))' }} />
        </div>

        {/* Title + active-selection pills */}
        <div className="flex-1 flex flex-col items-start min-w-0">
          <span className="text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface">
            {title}
          </span>
          {activePills.length > 0 && (
            <div className="flex gap-1 flex-wrap mt-0.5">
              {activePills.map(text => (
                <Pill key={text} text={text} type="user-choice" />
              ))}
            </div>
          )}
        </div>

        <ChevronIcon open={isOpen} />
      </button>

      {/* Expandable body */}
      {isOpen && (
        <div className="flex flex-col px-2 divide-y divide-outline/20">
          {children}
        </div>
      )}
    </div>
  )
}
